export enum IncidentStatus {
    AwaitingAcceptance = 1,
    Rejected = 2,
    AwaitingImprovements = 3,
    ReadyForApproval = 4,
    Closed = 5,
}
